<mat-icon svgIcon="info" color="primary" class="cursor-pointer" [matTooltip]="sentence" [matTooltipPosition]="position"></mat-icon>

